import * as React from "react";

function SvgStartIcon(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={16.804} height={16.804} {...props}>
        <path
          d="M8.4 0a8.347 8.347 0 00-5.941 2.461A8.348 8.348 0 000 8.402a8.347 8.347 0 002.461 5.941A8.347 8.347 0 008.4 16.804a8.348 8.348 0 005.942-2.461A8.347 8.347 0 0016.8 8.402a8.348 8.348 0 00-2.461-5.942A8.348 8.348 0 008.4 0zm0 15.623a7.176 7.176 0 01-2.809-.566 7.221 7.221 0 01-2.3-1.547 7.177 7.177 0 01-1.548-2.3 7.167 7.167 0 01-.568-2.811 7.176 7.176 0 01.566-2.809A7.226 7.226 0 013.3 3.297 7.176 7.176 0 015.6 1.75a7.157 7.157 0 012.8-.568 7.176 7.176 0 012.809.566 7.238 7.238 0 012.3 1.547 7.181 7.181 0 011.547 2.3 7.163 7.163 0 01.568 2.811 7.176 7.176 0 01-.566 2.809 7.232 7.232 0 01-1.547 2.3 7.181 7.181 0 01-2.3 1.548 7.173 7.173 0 01-2.811.56zM6.911 4.169a.585.585 0 00-.431.186.588.588 0 00-.16.423.586.586 0 00.186.412l3.409 3.2-3.41 3.2a.586.586 0 00-.186.412.587.587 0 00.16.423.585.585 0 00.43.186.589.589 0 00.4-.16l3.87-3.626a.591.591 0 00.187-.431.589.589 0 00-.185-.43l-3.87-3.627a.59.59 0 00-.4-.168z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgStartIcon;
